/**
 * @description Disables setup_future_usage if Klarna payment method is requested
 * @param requestPaymentMethodTypes - The payment method types requested
 * @param setupFutureUsage - Requested setup future usage option
 * @returns - The payment method types and setup future usage option
 */
export const getStripePaymentMethodsAndFutureUsage = (
	requestPaymentMethodTypes?: string[],
	setupFutureUsage?: 'on_session' | 'off_session' | null
): {
	payment_method_types?: string[];
	setup_future_usage?: 'on_session' | 'off_session';
} => {
	const disableFuturePayments = requestPaymentMethodTypes
		?.some((p) => ['klarna', 'card_present'].includes(p));

	return {
		payment_method_types: requestPaymentMethodTypes,
		setup_future_usage: disableFuturePayments ? undefined : (setupFutureUsage ?? undefined),
	};
};

/**
 * @description Returns the setup_future_usage Stripe option based on the product
 * @param product - The product of the payment
 * @param product.event - Whether the payment is for an event
 * @param product.membership - Whether the payment is for a membership
 * @param product.challenge - Whether the payment is for a challenge
 * @param product.blastPlan - Whether the payment is for a blast plan
 * @param product.eventBundle - Whether the payment is for an event bundle
 * @returns - The setup_future_usage Stripe option
 */
export const getStripeFutureUsage = (product: {
	event?: boolean;
	membership?: boolean;
	challenge?: boolean;
	blastPlan?: boolean;
	eventBundle?: boolean;
}): 'on_session' | 'off_session' | undefined => {
	if (product.membership) {
		return 'off_session';
	}

	if (product.event) {
		return 'off_session';
	}

	if (product.challenge) {
		return 'off_session';
	}

	if (product.blastPlan) {
		return 'off_session';
	}

	// default to off_session for other products
	return 'off_session';
};
